module.exports = __webpack_public_path__ + "static/media/31.76cb70cb.jpg";